import axios from 'axios';
import Auth from './auth';
import { API_ROOT } from './apiConfig';

export default class AdminSettingsDataAccess {
    url(account) {
        return `${API_ROOT}/api/v1/Admin/${account === null ? 'Features' : `Accounts/${encodeURIComponent(account)}/Settings`}`;
    }
    options() {
        return { headers: { Authorization: `Bearer ${new Auth().getToken()}` }, timeout: 30000 };
    }
    get(account) { return axios.get(this.url(account), this.options()).then(r => r.data); }
    save(account, key, request) {
        return axios.put(`${this.url(account)}/${encodeURIComponent(key)}`, request, this.options()).then(r => r.data);
    }
    impact(key) {
        return axios.get(`${this.url(null)}/${encodeURIComponent(key)}/Impact`, this.options()).then(r => r.data);
    }
    history(account, page, key) {
        return axios.get(`${this.url(account)}/History?page=${page}&pageSize=25&key=${encodeURIComponent(key)}`, this.options()).then(r => r.data);
    }
}



// WEBPACK FOOTER //
// ./src/services/adminSettingsDataAccess.js